import { IClassInfo } from "../interfaces/IClassInfo";
import { useMemo } from "react";

export const useSearch = (data: IClassInfo[], query: string) => {
    return useMemo(() => {
        return data.filter(c => query.split(' ').every(s => c.className.toLowerCase().includes(s.toLowerCase()) || c.description.toLowerCase().includes(s.toLowerCase())))
    }, [data, query]);
}